let checkIfFieldExist = setInterval(function() {
  let $calendarBtn = $('.section-calendar #event-calendar-app .widget-controls-right li:nth-child(1)');

  if ($calendarBtn.length) {
    clearInterval(checkIfFieldExist);
    $calendarBtn.trigger('click')
  }

}, 100);
